import React from "react";

function Loader(props) {
  if (!props.loading) {
    return null;
  }

  return <div className="loading">Loading&#8230;</div>;
}

export default Loader;
